<template>
  <div>
    <v-row>
      <v-col sm="11" md="11" lg="11">
        <v-dialog v-model="showLineItem" width="80%" persistent>
          <v-card class="overflow-x-hidden overflow-y-hidden containerbox">
            <!-- Header -->
            <v-card-title class="subtitle-2 primary customwhite--text">
              {{ lineMessage }}
              <v-spacer></v-spacer>
              <v-btn v-if="this.lineDialogType == 'edit' && lineData.order_line[0].isDeletable" outlined
                class="pa-0 mx-2" dense small title="Close" color="error" @click="onClickDeleteLineItem">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
              <v-btn outlined class="pa-0 mx-2" dense small title="Close" color="customwhite"
                @click="onClickLineItemCancel">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <!-- Line Type Selection -->
            <v-row class="pt-7">
              <v-col cols="12" sm="4" md="4" lg="4" class="px-5 py-0">
                <v-autocomplete color="primarytext" persistent-placeholder :menu-props="{ maxHeight: 160 }" attach
                  outlined class="ma-0 px-5" v-model="lineData.order_line[0].order_line_type" dense
                  :items="lineTypeList" label="Line Type" item-text="so_desc" item-value="sotype_id" required
                  :disabled="disableLine" @change="onChangeLineType">
                </v-autocomplete>
              </v-col>
            </v-row>
            <!-- Expandable Panels -->
            <v-expansion-panels flat multiple :value="expandedPanel" class="condensed pa-5 pt-2">
              <!-- Part Number Panel -->
              <v-expansion-panel class="col-box-border">
                <v-expansion-panel-header class="subtitle-2 primary customwhite--text">
                  Part Number to Receive
                </v-expansion-panel-header>
                <v-expansion-panel-content class="add-menu containerbox pt-2">
                  <v-form ref="partRecieveForm" lazy-validation @submit.prevent="submitForm"
                    :disabled="!lineData.order_line[0].order_line_type">
                    <part-search-comp :required="validationRules.required" :selectedPart="lineData"
                      :searchPartKey="searchPartKey" :showPartRetDetails="showPartRetDetails"
                      :returnResultList="returnResultList" @clear-part-return="clearPartReturn"
                      @search-part="returnPartData" @select-part="showReturnPartDesc"
                      :disableFlag="!lineData.order_line[0].isEditPart" />
                    <v-row class="pt-3 mx-0">
                      <v-col cols="12" sm="12" md="12" lg="3" class="px-5 py-0">
                        <v-autocomplete color="primarytext" persistent-placeholder outlined class="ma-0"
                          v-model="lineData.order_line[0].return_to_warehouse_id" dense :items="returnWareList"
                          label="Return To Warehouse" item-text="into_warebuck" item-value="ware_id" required
                          :rules="validationRules.required" :disabled="disableWarehouse || !lineData.order_line[0].isEditPart" @change="onChangeWarehouse">
                        </v-autocomplete>
                      </v-col>
                      <v-col v-if="lineTypeObj.receiveType == 'PO'" cols="12" sm="12" md="12" lg="3" class="px-5 py-0">
                        <v-autocomplete color="primarytext" persistent-placeholder outlined class="ma-0"
                          v-model="lineData.order_line[0].receive_grade" dense :items="returnCosmeticList"
                          label="Cosmetic Grade" item-text="cg_desc" item-value="rm_id" required
                          :rules="validationRules.required">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="2" class="px-5 py-0">
                        <v-text-field color="primarytext" persistent-placeholder @keypress="isNumber($event, 'number')"
                          :disabled="!lineData.order_line[0].isEditQty" v-model="lineData.order_line[0].return_quantity"
                          :rules="validationRules.qtyRule" label="Qty" outlined clearable dense class="ma-0"
                          @input="getExtCost">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="2" class="px-1 p py-0">
                        <v-text-field color="primarytext" persistent-placeholder :rules="validationRules.priceValid"
                          prefix="$" v-model="lineData.order_line[0].return_price"
                          @keypress="isNumber($event, 'pointer')"
                          :label="lineTypeObj.receiveType == 'SO' ? 'Credit' : 'Unit Cost'" outlined clearable dense
                          class="ma-0" @input="getExtCost">
                        </v-text-field>
                      </v-col>
                      <v-col v-if="lineTypeObj.receiveType == 'PO'" cols="12" sm="12" md="12" lg="2"
                        :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'px-1 pr-5 py-0': $vuetify.breakpoint.mdAndUp }">
                        <v-text-field color="primarytext" disabled persistent-placeholder :rules="priceValid" prefix="$"
                          v-model="lineData.order_line[0].receive_ext_cost" type="number" label="Ext Cost" outlined
                          clearable dense class="ma-0">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
                        <v-text-field color="primarytext" persistent-placeholder
                          v-model="lineData.order_line[0].return_rma" label="RMA" v-uppercase
                          :rules="validationRules.rmaValidataion" outlined clearable dense class="ma-0">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- Line Comments Panel -->
              <v-expansion-panel class="col-box-border">
                <v-expansion-panel-header class="subtitle-2 primary customwhite--text">
                  Line Comments and Flex Information
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" sm="4" md="4" lg="9" class="px-2 pt-10"></v-col>
                    <v-col cols="12" sm="8" md="8" lg="3" class="px-2 ma-0 pt-4">
                      <v-btn class="ma-2 btn-style float-right success" elevation="1" outlined color="cWhite"
                        @click="showFlexDialog = true">
                        <v-icon dark left>mdi-plus</v-icon>New Flex Item
                      </v-btn>
                    </v-col>
                  </v-row>

                  <!-- Flex Field Data Table -->
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="px-5 py-0 ma-0">
                      <v-data-table hide-default-footer height="300" disable-pagination
                        :headers="flexHeader" :items="lineData.order_line[0].flex_field" item-key="flex_code">
                        <template v-slot:item.actions="{ item }">
                          <v-icon small class="mr-2" @click="editFlexItem(item)">
                            mdi-pencil
                          </v-icon>
                          <v-icon color="error" small @click="deleteFlexItem(item)">
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <!-- Line Comments -->
                  <v-row class="pt-10">
                    <v-col cols="12" sm="12" md="12" lg="12" class="px-5 py-0">
                      <v-textarea persistent-placeholder name="CustLin" label="Line Comments"
                        v-model="lineData.order_line[0].line_comment" rows="4" outlined required dense>
                      </v-textarea>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- Flex Dialog Component -->
            <flex-dialog-comp :show.sync="showFlexDialog" :title="flexDialogTitle" :edit-item="currentFlexItem"
              @flex-added="onFlexItemAdded" />
            <!-- Actions -->
            <v-divider></v-divider>
            <v-row>
              <v-col sm="12" md="12" lg="12" class="pb-3 text-xs-right pr-5 pb-5 pt-5 d-flex justify-end">
                <v-btn class="ma-2 btn-style" outlined color="primary" elevation="1" @click="onClickSubmit">
                  Submit
                </v-btn>
                <v-btn class="ma-2 btn-style" outlined color="secondary" elevation="1" @click="onClickLineItemCancel">
                  Close
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <CommonDialog v-if="showDialog" :showDialog="showDialog" :message="showDeleteMessage"
      @onClickOkay="onClickOkayDialog()" @onClickCancelled="onClickCancelDialog" />
  </div>
</template>
<script>
import utility from '@/shared/utility';
import PartSearchComp from '../common/part-search-comp.vue';
import CommonDialog from '../common/common-dialog.vue';
import FlexDialogComp from '../common/flex-dialog-comp.vue';
import receiveSrvice from './js/receive-srvice';
import encryptUtility from '../utility/js/encrypt-utility';
export default {
  name: 'LineItemsDialogComp',
  components: {
    PartSearchComp,
    FlexDialogComp,
    CommonDialog
  },
  props: {
    showLineItem: Boolean,
    lineMessage: String,
    proj_key: String,
    lineTypeObj: Object,
    lineDialogType: Boolean,
  },
  data() {
    return {
      expandedPanel: [0],
      userId: encryptUtility.localStorageDecrypt("userID"),
      lineData: this.initLineData(),
      searchPartKey: "",
      showPartRetDetails: false,
      showDeleteMessage: "Are you sure you want to delete this line item?",
      showDialog: false,
      disableWarehouse: true,
      lineTypeList: [],
      returnResultList: [],
      returnWareList: [],
      returnCosmeticList: [],
      debouncedGetPartList: null,
      showFlexDialog: false,
      flexDialogTitle: 'New Flex Item',
      currentFlexItem: null,
      flexHeader: [
        { text: 'Field Code', value: 'flex_code', align: 'start', class: "primary customwhite--text", },
        { text: 'Field Value', value: 'flex_data', class: "primary customwhite--text", },
        { text: 'Actions', value: 'actions', sortable: false, class: "primary customwhite--text", }
      ],
      validationRules: {
        required: [v => !!v || 'This field is required'],
        qtyRule: [
          v => !!v || 'Quantity is required',
          v => (v && parseInt(v) > 0) || 'Quantity must be greater than 0',
          v => {
            const rcvd = this.lineData?.order_line?.[0]?.Rcvd;
            if (v && rcvd !== undefined && rcvd !== null && v < rcvd) {
              return `Quantity cannot be less than received (${rcvd})`;
            }
            return true;
          }
        ],
        priceValid: [
          v => !v || parseFloat(v) >= 0 || 'Price cannot be negative'
        ],
        rmaValidataion: []
      },
      tempDeletedFlex: [],
      // These would be props or computed if data was available
      disableLine: false,
      sameAsShip: false,
      disableRetQty: false
    };
  },
  async mounted() {
    if (this.lineDialogType == "edit") {
      if (this.lineTypeObj.receiveType == "PO") {
        let lineObj = {
          UserId: this.userId,
          line_id: this.lineTypeObj.line_id
        }
        let lineInfo = await receiveSrvice.postLineItemPODetails("post", lineObj, false);
        this.lineData = this.mapPOApiResponseToLineData(lineInfo.LineItem[0]);
        this.lineTypeList = lineInfo.LineItem[0].LineTypeInfo || [];
      }
      else {
        let lineData = await receiveSrvice.getLineItemDetails("get", this.userId, this.lineTypeObj.line_id, false);
        this.lineData.order_line = JSON.parse(JSON.stringify(lineData.LineItem));
        this.lineTypeList = this.lineData.order_line[0].LineTypeInfo || [];
      }
       this.fetchWarehouseData(this.lineData.order_line[0].return_part_number);
      this.lineData.order_line[0].is_Edited = true;
      this.lineData.order_line[0].orig_quantity = this.lineData.order_line[0].return_quantity;
      this.disableLine = true;
      this.searchPartKey = this.lineData.order_line[0].return_part_number;
      this.lineData.order_line[0].return_to_warehouse_id = this.lineData.order_line[0].return_to_warehouse_id + "_" + this.lineData.order_line[0].return_to_inventory_bucket;
      this.disableWarehouse = false;
      this.getExtCost()
      

    }
    else {
      this.lineData.order_line[0].is_Added = true;
    }
  },
  async created() {
    this.debouncedGetPartList = utility.debounce(this.getPartList, 500);
    this.lineDialogType == "edit" ? "" : this.getLineTypeList();
    this.initializeLineData();
  },
  methods: {
    initLineData() {
      return {
        so_id: "",
        proj_id: "",
        bu_id: "",
        order_line: [{
          order_line_type: "",
          return_part_id: "",
          return_part_number: "",
          return_part_description: "",
          return_to_warehouse_id: "",
          return_quantity: "",
          return_price: "",
          return_rma: "",
          return_to_warehouse: "",
          return_to_inventory_bucket: "",
          line_comment: "",
          flex_field: [],
          orig_quantity: "",
          is_Added: false,
          is_Deleted: false,
          is_Edited: false,
          isEditPart: true,
          isEditQty: true,
          isDeletable: true,
          item_line_id: "",
          sh_part_id: 0,
          Rcvd: "",
          receive_ext_cost: "",
        }]
      };
    },
    initializeLineData() {
      // Initialize with data from props
      this.lineData.proj_id = this.proj_key;
      this.lineData.so_id = this.lineTypeObj.detailsKey;
      this.lineData.bu_id = this.lineTypeObj.bu_key;
      this.lineData.order_line[0].return_rma = this.lineTypeObj.rma;
    },
    isNumber(event, loc) {
      return loc === "number"
        ? utility.isNumber(event)
        : utility.isNumberWithPeriod(event);
    },
    onClickLineItemCancel() {
      this.$emit('onClickLineItemCancel');
    },
    onChangeLineType() {
      // Implement line type change logic if needed
      this.clearPartReturn();
      this.disableLine = true
    },
    submitForm() {
      this.onClickSubmit();
    },
    async getLineTypeList() {
      try {
        if (this.lineTypeObj.receiveType == "SO") {
          const lineObj = {
            ProjKey: this.proj_key,
            UserId: this.userId,
            SOId: this.lineTypeObj.detailsKey,
            isAdd: this.lineTypeObj.line_id ? false : true,
          };
          const lineData = await receiveSrvice.postLineTypeList("post", lineObj, false);
          this.lineTypeList = lineData.LineTypeInfo || [];
        }
        else {
          const lineObj = {
            ProjKey: this.proj_key,
            UserId: this.userId,
            isAdd: this.lineTypeObj.line_id ? false : true,
          };
          const lineData = await receiveSrvice.postLineTypePOList("post", lineObj, false);
          this.lineTypeList = lineData.LineTypeInfo || [];
        }
      }
      catch (error) {
        console.error("Error fetching line type list:", error);
      }
    },
    returnPartData(value) {
      this.searchPartKey = value;
      if (value && value.length > 2) {
        this.showPartRetDetails = true;
        this.debouncedGetPartList();
      } else {
        this.showPartRetDetails = false;
      }
    },
    async getPartList() {
      try {
        if (this.lineTypeObj.receiveType == "SO") {
          const partObj = {
            UserId: this.userId,
            SearchStr: this.searchPartKey,
            BuKey: this.lineTypeObj.bu_key,
            order_type: this.lineTypeObj.ordertype_desc,
            sotype_key: this.lineData.order_line[0].order_line_type,
            ship_part_key: this.lineData.order_line[0].sh_part_id,
            line_key: 0
          };

          const partData = await receiveSrvice.postLinePartList("post", partObj, false);
          this.returnResultList = partData.Resultset || [];
        }
        else {
          const partObj = {
            UserId: this.userId,
            SearchStr: this.searchPartKey,
            order_bu_key: this.lineTypeObj.bu_key,
          };
          const partData = await receiveSrvice.postLinePartPOList("post", partObj, false);
          this.returnResultList = partData.Resultset || [];
        }
      }
      catch (error) {
        console.error("Error fetching part list:", error);
        this.returnResultList = [];
      }
    },
    clearPartReturn() {
      this.searchPartKey = "";
      this.lineData.order_line[0].return_part_number = "";
      this.lineData.order_line[0].return_part_description = "";
      this.lineData.order_line[0].return_part_id = "";
      this.showPartRetDetails = false;
      this.disableWarehouse = true;
    },
    async showReturnPartDesc(item) {
      this.lineData.order_line[0].return_part_number = item.part_num;
      this.lineData.order_line[0].return_part_description = item.part_desc;
      this.lineData.order_line[0].return_part_id = item.part_id;
      this.showPartRetDetails = false;
      this.disableWarehouse = false;
      await this.fetchWarehouseData(item.part_num);
    },
    async fetchWarehouseData(partNum) {
      try {
        let warehouseData = {};
        if (this.lineTypeObj.receiveType == "SO") {
          const warehouseObj = {
            part_num: partNum,
            order_type: this.lineTypeObj.ordertype_desc,
            sotype_key: this.lineData.order_line[0].order_line_type,
            order_bu_key: this.lineTypeObj.bu_key,
            line_id: this.lineData.order_line[0].item_line_id ? this.lineData.order_line[0].item_line_id : 0,
            so_key: this.lineTypeObj.detailsKey,
            UserId: this.userId,
          };

          warehouseData = await receiveSrvice.postLineWarehouseData("post", warehouseObj, false);
          this.lineData.order_line[0].Rcvd = warehouseData?.Rcvd;
          if (warehouseData?.LineType) {
            this.lineData.order_line[0].order_line_type = warehouseData.LineType;
          }
          if (warehouseData?.ReturnToWare) {
            this.returnWareList = warehouseData.ReturnToWare.map(x => ({
              ware: x.ware,
              ware_id: x.ware_id + "_" + x.bucket,
              bucket: x.bucket,
              into_warebuck: x.into_warebuck,
            }));
          }
        }
        else {
          const warehouseObj = {
            UserId: this.userId,
            line_id: 0,
            loca_key: this.lineTypeObj.rcvloc_key,
            part_num: partNum,
            order_bu_key: this.lineTypeObj.bu_key,
            order_type: this.lineTypeObj.ordertype_desc,
            po_key: this.lineTypeObj.detailsKey,
            potype_key: this.lineData.order_line[0].order_line_type,
          }
          warehouseData = await receiveSrvice.postLineWarehousePOData("post", warehouseObj, false);
          this.lineData.order_line[0].Rcvd = warehouseData?.Rcvd;
          if (warehouseData?.LineType) {
            this.lineData.order_line[0].order_line_type = warehouseData.LineType;
          }
          if (warehouseData?.ReceiveWare) {
            this.returnWareList = warehouseData.ReceiveWare.map(x => ({
              ware: x.ware,
              ware_id: x.ware_id + "_" + x.bucket,
              bucket: x.bucket,
              into_warebuck: x.into_warebuck,
              cg_desc: x.cg_desc,
              cos_grade: x.cos_grade,
              rm_id: x.rm_id,
            }));
            if (this.lineDialogType !== "edit") {
              this.lineData.order_line[0].return_price = warehouseData?.CostInfo[0]?.defaultcost?.toFixed(2);
            }
            this.onChangeWarehouse()
          }
        }
      } catch (error) {
        console.error("Error fetching warehouse data:", error);
        this.returnWareList = [];
      }
    },
    async onClickSubmit() {
      if (this.$refs.partRecieveForm.validate()) {
        if (this.lineData)
          if (this.dialogType != "edit") {
            this.lineData.order_line[0].orig_quantity = this.lineData.order_line[0].return_quantity;
          }
        this.lineData.order_line[0].return_to_warehouse = this.returnWareList.find(
          x => x.ware_id === this.lineData.order_line[0].return_to_warehouse_id
        )?.ware;
        // Extract warehouse ID before sending
        if (this.lineData.order_line[0].return_to_warehouse_id && this.lineTypeObj.receiveType == "SO") {
          this.lineData.order_line[0].return_to_inventory_bucket =
            this.lineData.order_line[0].return_to_warehouse_id.split("_")[1];
          this.lineData.order_line[0].return_to_warehouse_id =
            this.lineData.order_line[0].return_to_warehouse_id.split("_")[0];
        }
        else {
          this.lineData.order_line[0].receive_in_inventory_bucket =
            this.lineData.order_line[0].return_to_inventory_bucket.split("_")[1];
          this.lineData.order_line[0].receive_in_inventory_bucket =
            this.lineData.order_line[0].return_to_inventory_bucket.split("_")[0];
        }

        // Insert deleted flex items into flex_field before submit
        if (this.tempDeletedFlex && this.tempDeletedFlex.length > 0) {
          this.lineData.order_line[0].flex_field = [
            ...this.lineData.order_line[0].flex_field,
            ...this.tempDeletedFlex
          ];
          this.tempDeletedFlex = [];
        }

        const addObj = {
          UserId: this.userId,
          json: this.lineTypeObj.receiveType == "SO" ? JSON.stringify(this.lineData) : JSON.stringify(this.mapLineDataToPO())
        };
        const submitData = this.lineTypeObj.receiveType == "SO"
          ? await receiveSrvice.postLineItemAdd("post", addObj, false)
          : await receiveSrvice.postLineItemPOAdd("post", addObj, false);
        if (submitData.Result) {
          let Alert = {
            type: "success",
            isShow: true,
            message: "Line Item Updated successfully"
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.showLineItem = false;
          this.$refs.partRecieveForm.reset();
          this.$refs.partRecieveForm.resetValidation();
          this.$emit('onClickOkay');
        }
      }
    },
    // Flex item management methods
    editFlexItem(item) {
      this.flexDialogTitle = 'Edit Flex Item';
      this.currentFlexItem = { ...item };
      this.showFlexDialog = true;
    },

    deleteFlexItem(item) {
      const index = this.lineData.order_line[0].flex_field.findIndex(f =>
        f.flex_code === item.flex_code && f.flex_data === item.flex_data
      );
      if (index !== -1) {
        // Mark as deleted and store in temp array
        const deletedItem = { ...this.lineData.order_line[0].flex_field[index], is_Deleted: true };
        this.tempDeletedFlex.push(deletedItem);
        this.lineData.order_line[0].flex_field.splice(index, 1);
      }
    },

    onFlexItemAdded(item) {
      if (this.currentFlexItem) {
        // Editing existing item
        const index = this.lineData.order_line[0].flex_field.findIndex(f =>
          f.flex_code === this.currentFlexItem.flex_code &&
          f.flex_data === this.currentFlexItem.flex_data
        );

        if (index !== -1) {
          this.lineData.order_line[0].flex_field.splice(index, 1, item);
        }
      } else {
        // Adding new item
        this.lineData.order_line[0].flex_field.push(item);
      }

      this.currentFlexItem = null;
      this.flexDialogTitle = 'New Flex Item';
    },
    onClickDeleteLineItem() {
      this.showDialog = true;
    },
    onClickOkayDialog() {
      this.showDialog = false;
      this.lineData.order_line[0].is_Deleted = true;
      this.onClickSubmit()
    },
    onClickCancelDialog() {
      this.showDialog = false;
    },
    getExtCost() {
      if (this.lineData.order_line[0].return_price && this.lineData.order_line[0].return_quantity) {
        this.lineData.order_line[0].receive_ext_cost = (this.lineData.order_line[0].return_price * this.lineData.order_line[0].return_quantity).toFixed(2);
      }
    },
    onChangeWarehouse() {
      let cosmeticData = this.returnWareList?.filter((x) => x.ware_id == this.lineData.order_line[0].return_to_warehouse_id);
      this.returnCosmeticList = cosmeticData?.map((x) => ({
        cg_desc: x.cg_desc,
        rm_id: x.rm_id,
      }));
    },
    mapLineDataToPO() {
      const src = this.lineData;
      const srcLine = src.order_line[0] || {};
      return {
        proj_id: src.proj_id || "",
        bu_id: src.bu_id || "",
        po_id: this.lineTypeObj.detailsKey,
        order_line: [{
          item_line_id: srcLine.item_line_id || "",
          order_line_type: srcLine.order_line_type || "",
          receive_part_id: srcLine.receive_part_id || srcLine.return_part_id || "",
          receive_part_number: srcLine.receive_part_number || srcLine.return_part_number || "",
          receive_part_description: srcLine.receive_part_description || srcLine.return_part_description || "",
          receive_in_warehouse_id: srcLine.receive_in_warehouse_id || srcLine.return_to_warehouse_id.split("_")[0] || "",
          receive_in_inventory_bucket: srcLine.receive_in_inventory_bucket || srcLine.return_to_warehouse_id.split("_")[1],
          receive_quantity: srcLine.receive_quantity || srcLine.return_quantity || "",
          receive_unit_cost: srcLine.receive_unit_cost || srcLine.return_price || "",
          receive_rma: srcLine.receive_rma || srcLine.return_rma || "",
          line_comment: srcLine.line_comment || "",
          receive_grade:srcLine.receive_grade || "",
          flex_field: srcLine.flex_field || [],
          orig_quantity: srcLine.orig_quantity || "",
          is_Added: srcLine.is_Added || false,
          is_Deleted: srcLine.is_Deleted || false,
          is_Edited: srcLine.is_Edited || false,
          isEditPart: srcLine.isEditPart || true,
          isEditQty: srcLine.isEditQty || true,
          isDeletable: srcLine.isDeletable || true,
          line_id: srcLine.item_line_id || "",
          sh_part_id: srcLine.sh_part_id || 0,
          Rcvd: srcLine.Rcvd || "",
          receive_ext_cost: srcLine.receive_ext_cost || "",
        }]
      };
    },
    mapPOApiResponseToLineData(apiResponse) {
      // apiResponse: the full response object as shown in your prompt
      const item = apiResponse
      return {
        so_id: this.detailsKey, // If available, else set as needed
        proj_id: this.proj_key || "",
        bu_id: this.lineTypeObj?.bu_key || "",
        order_line: [this.mapPOOrderLineToInternal(item)]
      };
    },
    // Map a PO API order_line object to your internal order_line structure
    mapPOOrderLineToInternal(poOrderLine) {
      return {
        order_line_type: poOrderLine.order_line_type || "",
        return_part_id: poOrderLine.receive_part_id || "",
        return_part_number: poOrderLine.receive_part_number || "",
        return_part_description: poOrderLine.receive_part_description || "",
        return_to_warehouse_id: poOrderLine.receive_in_warehouse_id || "",
        return_to_warehouse: poOrderLine.receive_in_warehouse || "",
        return_to_inventory_bucket: poOrderLine.receive_in_inventory_bucket || "",
        return_quantity: poOrderLine.receive_quantity || "",
        return_cosmetic_grade: poOrderLine.receive_grade || "",
        return_price: poOrderLine.receive_unit_cost || "",
        return_rma: poOrderLine.receive_rma || "",
        line_comment: poOrderLine.line_comment || "",
        receive_grade: poOrderLine.receive_grade || "",
        flex_field: poOrderLine.flex_field || [],
        orig_quantity: poOrderLine.orig_quantity || "",
        is_Added: poOrderLine.is_Added || false,
        is_Deleted: poOrderLine.is_Deleted || false,
        is_Edited: poOrderLine.is_Edited || false,
        isEditPart: poOrderLine.isEditPart || false,
        isEditQty: poOrderLine.isEditQty || false,
        isDeletable: poOrderLine.isDeletable || false,
        item_line_id: poOrderLine.line_id || "",
        sh_part_id: poOrderLine.sh_part_id || 0,
        Rcvd: poOrderLine.Rcvd || "",
        receive_ext_cost: poOrderLine.receive_ext_cost || "",
      };
    },
  },

}
</script>

<style scoped>
.v-expansion-panels.condensed .v-expansion-panel--active:not(:first-child),
.v-expansion-panels.condensed .v-expansion-panel--active+.v-expansion-panel {
  margin-top: 5px;
}

.add-menu {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.v-expansion-panel--active>.v-expansion-panel-header {
  min-height: 40px;
}
</style>
